import React, {useState, useEffect} from 'react'

import classes from './PopupCatalogueItem.module.css'
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Popup from '@/components/shared/Popup/Popup';
import CatalogueItem from '../PopupCatalogue/CatalogueItem/CatalogueItem';
import { FaArrowLeft, FaArrowRight, FaXmark } from 'react-icons/fa6';
import Button from '@/components/shared/Button/Button';
import clsx from 'clsx';
import SoundPlayer from 'react-sdk/SoundPlayer';


const PopupCatalogueItem = () => {

  const [closing, setClosing] = useState(false);
  const [page, setPage] = useState(0);

  const items = PopupsManager.getData(POPUPS.CATALOGUE_ITEM)

  const item = items[page]


  function handleClose() {
    SoundPlayer.playSound("catalog_unlock_close")
    setClosing(true)

    setTimeout(() => {
      PopupsManager.close(POPUPS.CATALOGUE_ITEM)
    }, 600)
  }

  return (
    <Popup className={clsx(classes.PopupCatalogueItem, closing && classes.closing)}>
      <div className={classes.content}>
        {page > 0 &&
        <Button className={classes.arrow_left} onClick={() => setPage(p => p-1)} icon={<FaArrowLeft />} />}

        {page < items.length -1 &&
        <Button className={classes.arrow_right} onClick={() => setPage(p => p+1)} icon={<FaArrowRight />} />}
        {page == (items.length-1) &&
        <Button className={classes.close} icon={<FaXmark />} onClick={handleClose} />}
        <CatalogueItem item={item} autoplayAudio />
      </div>
      {items.length > 1 &&
      <div className={classes.pages} >
        <div>{page + 1} / {items.length}</div>
      </div>}
    </Popup>
  );
};

export default PopupCatalogueItem;
